import React from 'react';
import { getAppHost } from "../../utils";

import { _api } from "../../config/environment";
import { _envParams } from "../../config/env_params";

import AuthLayout from './AuthLayout/AuthLayout';

const AuthenticationLayout = (props) => {

    const appHost = getAppHost();
    const defaultHost = _api.appUrl;

    return (
        <>
                <AuthLayout {...props} />
        </>
    )
}

export default AuthenticationLayout 